/**
 * Przewija do pierwszego komunikatu błędu w kolejności DOM i zwraca, czy w
 * ogóle było co pokazać.
 *
 * `InputError` znaczy każdy komunikat atrybutem `data-form-error`, więc jedno
 * zapytanie obejmuje całą walidację formularza — także błędy spoza
 * react-hook-form (np. z wyceny). `center` zamiast `nearest`, bo formularze z
 * przyklejoną stopką chowałyby komunikat pod nią.
 *
 * Celowo bez ogniskowania kontrolki: na telefonie fokus w polu otwiera
 * klawiaturę, która zasłania pół ekranu i rozjeżdża trwające przewijanie, a
 * w react-selekcie i date pickerze od razu rozwija listę. Klient ma zobaczyć
 * komunikat, a kursor postawić sam.
 */
export const scrollToFirstFormError = (
  container?: HTMLElement | null,
): boolean => {
  const scope: ParentNode = container ?? document;
  const error = scope.querySelector('[data-form-error]');
  if (!error) return false;

  error.scrollIntoView({ behavior: 'smooth', block: 'center' });
  return true;
};

export default scrollToFirstFormError;
